import React, { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import { OfferProvider } from "./contexts/OfferContext";
import { SalesPage } from "./pages/SalesPage";
import { injectTrackingScript } from "./utils/tracking";
export function App() {
  useEffect(() => {
    injectTrackingScript();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3fbj8evsndfrq">
      <OfferProvider data-id="element-1" data-mp="3f8nd7f86p56z">
        <SalesPage data-id="element-2" data-mp="2rknmgfavhese" />
      </OfferProvider>
    </MotionConfig>;
}